<template>
	<div class="payDetails">
		<el-tabs v-model="listState" @tab-click="filterFun">
			<el-tab-pane v-for="item in listStateList" :key="item.id" :label="item.value"
				:name="item.id + ''"></el-tab-pane>
		</el-tabs>

		<div class="filter-container">
			<div class="filter-item" v-if="listState == 0">
				<label class="label" style="width: 75px;text-align: right;">支付时间:</label>
				<el-date-picker v-model="tab1Params.dateRange" type="datetimerange" format="yyyy-MM-dd HH:mm" :clearable="false" :default-time="['00:00:00','23:59:59']"
     				 value-format="yyyy-MM-dd HH:mm" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
				</el-date-picker>
			</div>
			<div class="filter-item" v-if="listState == 1">
				<label class="label" style="width: 75px;text-align: right;">退款时间:</label>
				<el-date-picker v-model="tab2Params.dateRange" type="datetimerange" format="yyyy-MM-dd HH:mm" :clearable="false" :default-time="['00:00:00','23:59:59']"
     				 value-format="yyyy-MM-dd HH:mm" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
				</el-date-picker>
			</div>
		</div>
		<div class="filter-container">
			<div class="filter-item" v-if="listState == 0" style="vertical-align: top;">
				<label class="label" style="width: 75px;display: inline-block;text-align: right;">关键字:</label>
				<el-select v-model="tab1Params.KeyWordsType" placeholder="请选择" style="width: 160px;margin-right: 10px;">
					<el-option :value="0" label="订单编号"></el-option>
					<el-option :value="1" label="销售推手"></el-option>
					<el-option :value="2" label="推手上级"></el-option>
					<el-option :value="3" label="最高级别推手"></el-option>
				</el-select>
				<el-input @keyup.enter.native="doorListFilter" v-model="tab1Params.KeyWords"
					:placeholder="tab1Params.KeyWordsType != 0 ? '推手姓名、手机号、微信昵称' : '订单编号'"
					style="width: 250px;" clearable></el-input>
			</div>
			<div class="filter-item" v-if="listState == 0" style="vertical-align: top;">
				<label class="label">推手级别:</label>
				<el-select v-model="tab1Params.DistibutorRoleId">
					<el-option label="全部" :value="null"></el-option>
					<el-option v-for="item in gradeOptions" :key="item.AgentRoleId" :label="item.AgentRoleName"
						:value="item.AgentRoleId"></el-option>
				</el-select>
			</div>

			<div class="filter-item" v-if="listState == 1" style="vertical-align: top;">
				<label class="label" style="width: 75px;display: inline-block;text-align: right;">关键字:</label>
				<el-select v-model="tab2Params.KeyWordsType" placeholder="请选择" style="width: 160px;margin-right: 10px;">
					<el-option :value="0" label="退款单号"></el-option>
					<el-option :value="1" label="销售推手"></el-option>
					<el-option :value="2" label="推手上级"></el-option>
					<el-option :value="3" label="最高级别推手"></el-option>
				</el-select>
				<el-input @keyup.enter.native="doorListFilter" v-model="tab2Params.KeyWords"
					:placeholder="tab2Params.KeyWordsType != 0 ? '推手姓名、手机号、微信昵称' : '退款单号'"
					style="width: 250px;" clearable></el-input>
			</div>
			<div class="filter-item" v-if="listState == 1" style="vertical-align: top;">
				<label class="label">推手级别:</label>
				<el-select v-model="tab2Params.DistibutorRoleId">
					<el-option label="全部" :value="null"></el-option>
					<el-option v-for="item in gradeOptions" :key="item.AgentRoleId" :label="item.AgentRoleName"
						:value="item.AgentRoleId"></el-option>
				</el-select>
			</div>

			<div class="filter-item">
				<el-button type="primary" style="width:90px;" @click="doorListFilter">查询</el-button>
				
				<buttonPermissions :datas="'agentSalesDetailExport'">
					<el-button style="margin-left:20px;width:90px;" @click="exportFun">导出</el-button>
				</buttonPermissions>
			</div>
		</div>
		<!-- 订单表格 -->
		<div class="table-container" v-show="listState == 0">
			<el-table :data="tab1Params.groupData" v-loading="loading">
				<el-table-column label="推手信息">
					<template slot-scope="scope">
						<div class="ellipsis-one">{{ scope.row.Name || scope.row.WxNickname }}</div>
						<div>{{ scope.row.Phone }}</div>
					</template>
				</el-table-column>
				<el-table-column prop="OrderNo" label="订单编号">
					<template slot-scope="scope">
						<el-button @click="openNewOrderNo(scope.row)" type="text">{{ scope.row.OrderNo }}</el-button>
					</template>
				</el-table-column>
				<el-table-column prop="RealPayMoney" label="实付金额(不含运费; 元)"></el-table-column>
				<el-table-column prop="PayTime" label="支付时间"></el-table-column>
			</el-table>
			<div style="text-align: right;">
				<el-pagination v-if="tab1Params.Total" style="margin:20px 0" @size-change="handleSizeChange"
					@current-change="handleCurrentChange" :current-page="tab1Params.currentPage" :page-sizes="[10, 20, 30, 40, 50]"
					:page-size="tab1Params.pageSize" layout="total, sizes, prev, pager, next, jumper"
					:total="tab1Params.Total"></el-pagination>
			</div>
		</div>

		<!-- 退款单表格 -->
		<div class="table-container" v-show="listState == 1">
			<el-table :data="tab2Params.groupData" v-loading="loading">
				<el-table-column label="推手信息" width="220">
					<template slot-scope="scope">
						<div class="ellipsis-one">{{ scope.row.Name || scope.row.WxNickname }}</div>
						<div>{{ scope.row.Phone }}</div>
					</template>
				</el-table-column>
				<el-table-column prop="SupportNo" label="退款单号">
					<template slot-scope="scope">
						<el-button @click="openNewSupportNo(scope.row)" type="text">{{ scope.row.SupportNo
							}}</el-button>
					</template>
				</el-table-column>
				<el-table-column prop="RefundMoney" label="退款金额(不含运费; 元)"></el-table-column>
				<el-table-column prop="CompleteTime" label="退款时间"></el-table-column>
				<el-table-column prop="OrderNo" label="原订单号">
					<template slot-scope="scope">
						<el-button @click="openNewOrderNo(scope.row)" type="text">{{ scope.row.OrderNo
							}}</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div style="text-align: right;">
				<el-pagination v-if="tab2Params.Total" style="margin:20px 0" @size-change="handleSizeChange"
					@current-change="handleCurrentChange" :current-page="tab2Params.currentPage" :page-sizes="[10, 20, 30, 40, 50]"
					:page-size="tab2Params.pageSize" layout="total, sizes, prev, pager, next, jumper"
					:total="tab2Params.Total"></el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
import { AgentfilterBoxList } from "@/api/TurnTomySelf.js";
import apiList from "@/api/other";
import config from "@/config/index";
import buttonPermissions from '@/components/buttonPermissions';
export default {
	components: {
		buttonPermissions
	},
	data() {
		return {
			MemberId: null,
			
			OrderFrom: 0,
			OrderFromlist: [
				{
					value: 0,
					label: '小程序商城订单'
				}, {
					value: 1,
					label: '视频号小店订单'
				},
			],
			loading: false,
			listStateList: [
				{
					id: '0',
					value: "销售单明细"
				},
				{
					id: 1,
					value: "退款单明细"
				}
			],
			gradeOptions: [],
			listState: "0",
			
			
			exportUrl: config.EXPORT_URL,
			goUrls: config.GO_URL,
			SellTotal: 0,
			RefundTotal: 0,
			
			tab1Params: {
				KeyWordsType: 0,
				KeyWords: "",
				DistibutorRoleId: null,
				dateRange: [],
				currentPage: 1,
				pageSize: 20,
				Total: 0,
				groupData: [],
			},
			tab2Params: {
				KeyWordsType: 0,
				KeyWords: "",
				DistibutorRoleId: null,
				dateRange: [],
				currentPage: 1,
				pageSize: 20,
				Total: 0,
				groupData: [],
			}

		};
	},
	created() {
		this.getAuthList();
	},
	beforeMount() {
		
		this.KeyWords = this.$route.query.KeyWords ? this.$route.query.KeyWords : "";
		if (this.$route.query.phone) {
			this.tab1Params.KeyWords = this.$route.query.phone;
			this.tab1Params.KeyWordsType = 1;
			this.tab1Params.dateRange = [this.$route.query.start, this.$route.query.end];

			this.tab2Params.KeyWords = this.$route.query.phone;
			this.tab2Params.KeyWordsType = 1;
			this.tab2Params.dateRange = [this.$route.query.start, this.$route.query.end];
		}else{
			this.initTime();
		}

		this.getList();
	},
	methods: {
		async getAuthList() {
			try {
				let result = await AgentfilterBoxList();
				this.gradeOptions = result.Result;
			} catch (e) {
			}
		},
		//跳转到订单详情
		openNewOrderNo(row) {
			let OrderNoId = row.OrderNo ? row.OrderNo : 0;
			let headsUrls = process.env.NODE_ENV == "production" ? "index.html#" : "";
			let url =
				this.goUrls + headsUrls + (this.OrderFrom == 0 ? '/order/orderDetailpage' : '/videoShop/videoOrderDetails') + '?Id=' + OrderNoId;
			window.open(url);
		},
		openNewSupportNo(row) {
			let SupportNoId = row.SupportNo ? row.SupportNo : 0;
			let headsUrls = process.env.NODE_ENV == "production" ? "index.html#" : "";
			let url = this.goUrls + headsUrls + (this.OrderFrom == 0 ? "/order/refundAfterSale/refundDetails" : "/videoShop/videoAfterSaleDetails") + "?id=" + row.SupportNo;
			window.open(url);
		},
		async getList() {
			try {
				this.loading = true;

				let obj = {};
				if (this.listState == 0){
					obj = this.tab1Params;
				}else{
					obj = this.tab2Params;
				}

				let data = {
					KeyWords: obj.KeyWords,
					KeyWordsType: obj.KeyWordsType,
					AgentRoleId: obj.DistibutorRoleId,
					Skip: (obj.currentPage - 1) * obj.pageSize, // 略过数据
					Take: obj.pageSize, // 取的数据
				};

				if (this.listState == 0){
					data.PayStartTime = obj.dateRange[0];
					data.PayEndTime = obj.dateRange[1];
				}
				if (this.listState == 1){
					data.StartTime = obj.dateRange[0];
					data.EndTime = obj.dateRange[1];
				}

				let result = {};
				if (this.listState == 0) {
					result = await apiList.salesDataOrderDetail(data);
				} else {
					result = await apiList.salesDataRefundOrderDetail(data);
				}
				if (this.listState == 0){
					this.tab1Params.Total = result.Result.Total;
					this.tab1Params.groupData = result.Result.Results || [];
				}else{
					this.tab2Params.Total = result.Result.Total;
					this.tab2Params.groupData = result.Result.Results || [];
				}
				
			} catch (e) {
				console.log(e);
			} finally {
				this.loading = false;
			}
		},
		filterFun() {
			// this.MemberId = null;
			// // this.KeyWordsType = 0;
			// // this.KeyWords = "";
			// this.DistibutorRoleId = null;
			// this.OrderFrom = 0
			// this.currentPage = 1;
			// this.pageSize = 20;
			this.getList();
		},
		initTime() {
			let date = new Date();
			let year = date.getFullYear();
			let month = date.getMonth() + 1 > 9 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1);
			let day = date.getDate() > 9 ? date.getDate() : "0" + date.getDate();
			let hour = date.getHours() > 9 ? date.getHours() : "0" + date.getHours();
			let minute = date.getMinutes() > 9 ? date.getMinutes() : "0" + date.getMinutes();
			let second = date.getSeconds() > 9 ? date.getSeconds() : "0" + date.getSeconds();
			this.StartTime = year + "-" + month + "-" + "01" + " " + "00:00:00";
			this.EndTime = year + "-" + month + "-" + day + " " + `${hour}:${minute}:${second}`;
			this.tab1Params.dateRange = [this.StartTime, this.EndTime];
			this.tab2Params.dateRange = [this.StartTime, this.EndTime];
		},
		// 查询
		doorListFilter() {
			this.currentPage = 1;
			this.getList();
		},
		exportFun() {
			let api = '';
			let obj = {};
			if (this.listState == 0){
				obj = this.tab1Params;
				api = "/pc/agent/salesDataOrderDetailExport";
			}else{
				obj = this.tab2Params;
				api = "/pc/agent/salesDataRefundOrderDetailExport";
			}

			let url = this.exportUrl + api + "?" +
				"KeyWordsType=" + obj.KeyWordsType +
				"&KeyWords=" + obj.KeyWords +
				"&AgentRoleId=" + (obj.DistibutorRoleId || "");

			if (this.listState == 0){
				url += "&PayStartTime=" + obj.dateRange[0] + "&PayEndTime=" + obj.dateRange[1];
			}else{
				url += "&StartTime=" + obj.dateRange[0] + "&EndTime=" + obj.dateRange[1];
			}
			
			console.log(url)

			window.open(url);
		},
		handleSizeChange(val) {
			if (this.listState == 0){
				this.tab1Params.pageSize = val;
			}else{
				this.tab2Params.pageSize = val;
			}
			this.getList();
		},

		handleCurrentChange(val) {
			if (this.listState == 0){
				this.tab1Params.currentPage = val;
			}else{
				this.tab2Params.currentPage = val;
			}
			this.getList();
		}
	}
};
</script>

<style lang="less" scoped>

.ellipsis-one{
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.payDetails {
	background: #fff;
	padding: 15px;
}
</style>
